import { useFlow } from 'contexts/Flow/flowContext'
import useTranslator from 'utils/hooks/Translator'
import useAccessControlLayer from 'utils/hooks/useAccessControlLayer'

import { CircularProgress } from '@material-ui/core'
import { useFintalkCloud } from 'contexts/FintalkCloud/fintalkCloudContext'
import { useState } from 'react'
import WithHasAccess from 'utils/WithHasAccess'
import * as S from './styles'

export default function ModalBlockedGroup() {
  const classes = S.useStyles()
  const { currentData } = useFintalkCloud()
  const { state, verifyEditGroup } = useFlow()
  const { hasPermissionToResource, isFintalkStaff } = useAccessControlLayer()
  const { getTranslation } = useTranslator()
  const [isLoading, setIsLoading] = useState(false)

  const handleEdit = async () => {
    if (currentData.groupName && currentData.agentName) {
      setIsLoading(true)
      await verifyEditGroup(currentData.groupName, currentData.agentName)
      setIsLoading(false)
    }
  }

  if (state.isEditing) return <></>

  return (
    <S.Container>
      <S.ContentContainer>
        <S.ModalTitle
          classes={{
            h6: classes.modalTitle,
          }}
        >
          {getTranslation('visualizationMode.title')}
        </S.ModalTitle>
        {(hasPermissionToResource(['edit']) || isFintalkStaff()) && (
          <S.TextContainer>
            {getTranslation('visualizationMode.subtitle')}
          </S.TextContainer>
        )}
      </S.ContentContainer>
      <S.ButtonContainer>
        <WithHasAccess action={['flow:write']}>
          <S.ButtonOk
            color="primary"
            variant={'contained'}
            onClick={handleEdit}
            disabled={!currentData.groupName || isLoading}
            className={classes.buttonOk}
          >
            {isLoading ? (
              <CircularProgress size={16} style={{ color: '#fff' }} />
            ) : (
              getTranslation('visualizationMode.button')
            )}
          </S.ButtonOk>
        </WithHasAccess>
      </S.ButtonContainer>
    </S.Container>
  )
}
